import { render, staticRenderFns } from "./BudgetBalances.vue?vue&type=template&id=d5db841e&"
import script from "./BudgetBalances.vue?vue&type=script&lang=js&"
export * from "./BudgetBalances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports